import React from "react";
import { Button } from "antd";

// Keeps a crash inside one admin page from blanking the whole app.
class PageErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="adm-card adm-empty">
        <p style={{ fontWeight: 700, color: "var(--adm-ink)" }}>This page ran into a problem.</p>
        <p>{String(this.state.error?.message || this.state.error)}</p>
        <Button onClick={() => window.location.reload()}>Reload</Button>
      </div>
    );
  }
}

export default PageErrorBoundary;
